let translator = (value) => (value === undefined || value === null ? value : `${value}`);

export const setGlobalTranslator = (fn) => {
  if (typeof fn === 'function') {
    translator = fn;
  }
};

export const translateRaw = (value, options) => translator(value, options);
